export const COMPUTER_SETUP_CHECKLIST_UPSELL_NAME = 'computer_setup_checklist_sidebar';
export const COMPUTER_SETUP_CHECKLIST_HOMEPAGE_WIDGET_UPSELL_NAME = 'computer_setup_checklist_homepage_widget';
export const COMPUTER_SETUP_CHECKLIST_HOMEPAGE_WIDGET_APP_LOCATION = 'HOMEPAGE_UNDER_INPUT_WIDGET';
export const DEFAULT_COMPUTER_SETUP_CHECKLIST_ID = 'computer_setup';
//# sourceMappingURL=types.js.map